// Carismo avatar landing pages — shared behaviour for sections/lp-*.liquid (layout/lp.liquid).
// Every component is opt-in via data attributes so each page only carries what it uses.
// In the Shopify port each block becomes a theme section; this file maps 1:1 to their JS.

// Vehicle list for the Make -> Model picker. Links are real carismodesign.com URLs.
// `url` = the model's collection, `build` = its [Build Your Own] product where one exists.
window.CARISMO_VEHICLES = {
  'BMW': [
    { label: 'M2 / 2 Series (G87 / G42)', url: '/collections/bmw-2-series-g42-m2-g87', build: '/products/build-your-own-custom-steering-wheel-for-bmw-g-series-m-performance-wheel', note: 'Pre-LCI and LCI cars use different wheels. The next page shows photos to match yours.' },
    { label: 'M3 / 3 Series (G80 / G20)', url: '/collections/bmw-3-series-g20-m3-g80', build: '/products/build-your-own-custom-steering-wheel-for-bmw-g-series-m-performance-wheel', note: 'Pre-LCI and LCI cars use different wheels. The next page shows photos to match yours.' },
    { label: 'M4 / 4 Series / i4 (G82 / G22 / G26)', url: '/collections/bmw-4-series-g22-i4-g26-m4-g82', build: '/products/build-your-own-custom-steering-wheel-for-bmw-g-series-m-performance-wheel', note: 'Pre-LCI and LCI cars use different wheels. The next page shows photos to match yours.' },
    { label: 'M5 / 5 Series (F90 / G30)', url: '/collections/bmw-5-series-g30-m5-f90', note: 'Match the photo of your current wheel on the next page.' },
    { label: 'M3 / 3 Series (F80 / F30)', url: '/collections/bmw-3-series-f30-m3-f80', build: '/products/build-your-own-custom-steering-wheel-for-bmw-f-series-m-performance-wheel', note: 'M Performance and standard wheels differ. The next page shows both.' },
    { label: 'M4 / 4 Series (F82 / F32)', url: '/collections/bmw-4-series-f32-m4-f82', build: '/products/build-your-own-custom-steering-wheel-for-bmw-f-series-m-performance-wheel', note: 'M Performance and standard wheels differ. The next page shows both.' }
  ],
  'Mercedes/AMG': [
    { label: 'C-Class / C 63', url: '/collections/mercedes-amg-c-class-c-63-s', note: 'Each generation has its own wheel. Pick yours by photo on the next page.' },
    { label: 'E-Class / E 63', url: '/collections/mercedes-amg-e-class-e-63-s', note: 'Each generation has its own wheel. Pick yours by photo on the next page.' },
    { label: 'G-Class / G 63', url: '/collections/mercedes-amg-g-class-g-63', note: 'Each generation has its own wheel. Pick yours by photo on the next page.' },
    { label: 'GT / GT R', url: '/collections/mercedes-amg-gt-gt-r', note: 'Each generation has its own wheel. Pick yours by photo on the next page.' },
    { label: 'Other AMG models', url: '/collections/mercedes-amg', note: 'All AMG models we build for.' }
  ],
  'Audi': [
    { label: 'A3 / S3 / RS3', url: '/collections/audi-a3-s3-rs3', note: 'Flat-bottom and round wheels differ. Match yours by photo.' },
    { label: 'A4 / S4 / RS4 (B9)', url: '/collections/audi-a4-s4-rs4-b9', build: '/products/build-your-own-custom-steering-wheel-for-audi-b9-wheel', note: 'Flat-bottom and round wheels differ. Match yours by photo.' },
    { label: 'A4 / S4 / RS4 (B9.5)', url: '/collections/audi-a4-s4-rs4-b9-5', build: '/products/build-your-own-custom-steering-wheel-for-audi-b9-5-wheel', note: 'Flat-bottom and round wheels differ. Match yours by photo.' },
    { label: 'A5 / S5 / RS5', url: '/collections/audi-a5-s5-rs5', note: 'Flat-bottom and round wheels differ. Match yours by photo.' },
    { label: 'R8', url: '/collections/audi-r8', build: '/products/build-your-own-custom-steering-wheel-for-audi-r8-gen-2', note: 'Gen 1 and Gen 2 use different wheels.' }
  ],
  'Porsche': [
    { label: '911 (992)', url: '/collections/porsche-911-992', build: '/products/build-your-own-custom-steering-wheel-for-porsche-992-1-wheel', note: 'Match the photo of your current wheel on the next page.' },
    { label: '911 (991.2)', url: '/collections/porsche-911-991-2', build: '/products/build-your-own-custom-steering-wheel-for-porsche-991-2-wheel', note: 'Match the photo of your current wheel on the next page.' },
    { label: '911 (997.2)', url: '/collections/porsche-911-997-2', build: '/products/build-your-own-custom-steering-wheel-for-porsche-997-2-wheel', note: 'Match the photo of your current wheel on the next page.' }
  ],
  'Lamborghini': [
    { label: 'Huracán', url: '/collections/lamborghini-huracan-1', build: '/products/build-your-own-custom-steering-wheel-for-lamborghini-huracan', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'Urus', url: '/collections/lamborghini-urus-1', build: '/products/build-your-own-custom-steering-wheel-for-lamborghini-urus', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'Aventador', url: '/collections/lamborghini-aventador-1', build: '/products/build-your-own-custom-steering-wheel-for-lamborghini-aventador', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'Revuelto', url: '/collections/lamborghini-revuelto', build: '/products/build-your-own-custom-steering-wheel-for-lamborghini-revuelto', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'Gallardo', url: '/collections/lamborghini-gallardo-1', build: '/products/build-your-own-custom-steering-wheel-for-lamborghini-gallardo', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' }
  ],
  'McLaren': [
    { label: '720S / 765LT', url: '/collections/mclaren-720s-765lt-1', build: '/products/build-your-own-custom-steering-wheel-for-mclaren-super-series', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: '650S / 675LT', url: '/collections/mclaren-650s-675lt-1', build: '/products/build-your-own-custom-steering-wheel-for-mclaren-sports-series', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: '570S / 600LT', url: '/collections/mclaren-570s-600lt-1', build: '/products/build-your-own-custom-steering-wheel-for-mclaren-sports-series', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'GT', url: '/collections/mclaren-gt-1', build: '/products/build-your-own-custom-steering-wheel-for-mclaren-super-series', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' },
    { label: 'Artura', url: '/collections/mclaren-artura-1', build: '/products/build-your-own-custom-steering-wheel-for-mclaren-sports-series', note: 'Built to your spec: carbon, leather or Alcantara, stitching and stripe.' }
  ],
  'Tesla': [
    { label: 'Model 3 (pre-2023 facelift)', url: '/collections/tesla-model-3', build: '/products/build-your-own-custom-steering-wheel-for-tesla-model-3-y', note: 'Heating is included on our Tesla wheels.' },
    { label: 'Model 3 (2023 facelift)', url: '/collections/tesla-model-3-2023-facelift', build: '/products/build-your-own-custom-steering-wheel-for-tesla-model-3-2023-facelift', note: 'The facelift uses a different wheel from earlier Model 3s.' },
    { label: 'Model Y', url: '/collections/tesla-model-y-1', build: '/products/build-your-own-custom-steering-wheel-for-tesla-model-3-y', note: 'Heating is included on our Tesla wheels.' },
    { label: 'Model S / X', url: '/collections/tesla', note: 'Pre-2021 and Plaid cars use different wheels.' }
  ],
  'Nissan': [{ label: 'GT-R', url: '/collections/nissan-gt-r', note: 'R35 CBA/DBA, R35 EBA and R34 each have their own wheel.' }],
  'Chevrolet': [{ label: 'Corvette', url: '/collections/chevrolet-corvette', note: 'C6, C7 and C8 each have their own wheel.' }],
  'Toyota': [{ label: 'Supra', url: '/collections/toyota-supra', note: 'Match the photo of your current wheel on the next page.' }],
  // Always offered last in every picker, so no visitor hits a dead end.
  'Other / not listed': [
    { label: "My car isn't listed", url: '/collections/all', build: '/collections/all',
      note: "Browse every wheel we build, or message us a photo of your steering wheel and we'll tell you what fits." }
  ]
};

(function () {
  const SITE = ''; // relative, so theme previews stay inside the preview
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Prototype-only notice: buttons that would hit Shopify cart/booking APIs show a toast instead.
  function toast(msg) {
    let t = $('#lp-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'lp-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('is-on'), 3400);
  }

  // ---- Sticky mobile CTA: shown unless the hero CTA is fully on screen ----
  // Covers both directions: scrolled past it, and not reached yet on short screens or inside Meta's
  // in-app browser (its toolbar eats ~90px), so the first screen always carries a whole, tappable action.
  // Keep `data-hero-cta` on a short element (a button, or a picker's select row) so it can be fully visible.
  // Research: a sticky bar that only scrolls does nothing; one that opens the buy drawer lifted orders.
  const sticky = $('[data-sticky-cta]');
  const heroCta = $('[data-hero-cta]');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-on', entry.intersectionRatio < 0.99);
    }, { threshold: [0, 0.99, 1] }).observe(heroCta);
  }

  // ---- Buy drawer (bottom sheet on phones, side sheet on desktop) ----
  const drawer = $('[data-drawer]');
  let lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    const first = $('.chip, button, [href]', $('.drawer__panel', drawer));
    first && first.focus({ preventScroll: true });
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; lastFocus && lastFocus.focus({ preventScroll: true }); }, reduceMotion ? 0 : 260);
  }
  $$('[data-open-drawer]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-close-drawer]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Option chips: single-select groups that update a price readout and the product-page link.
  $$('[data-chip-group]').forEach((group) => {
    const chips = $$('[data-chip]', group);
    const apply = (chip) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      const price = group.dataset.priceTarget && $(group.dataset.priceTarget);
      if (price && chip.dataset.price) price.textContent = chip.dataset.price;
      const note = group.dataset.noteTarget && $(group.dataset.noteTarget);
      if (note && chip.dataset.note) note.textContent = chip.dataset.note;
      const link = group.dataset.linkTarget && $(group.dataset.linkTarget);
      if (link && chip.dataset.href) link.href = SITE + chip.dataset.href;
      // Single-variant products add straight to the cart; anything with options goes to its product page.
      const add = group.dataset.addTarget && $(group.dataset.addTarget);
      const opts = group.dataset.optionsTarget && $(group.dataset.optionsTarget);
      if (add) {
        const addable = chip.dataset.addable === 'true';
        add.dataset.variantId = chip.dataset.variant || '';
        add.hidden = !addable;
        if (opts) {
          opts.hidden = addable;
          if (chip.dataset.href) opts.href = SITE + chip.dataset.href;
        }
        // Without add-to-cart the button already goes to the product page, so drop the duplicate link.
        const details = document.querySelector('[data-details-link]');
        if (details) details.hidden = !addable;
      }
    };
    chips.forEach((chip) => chip.addEventListener('click', () => apply(chip)));
    const preset = chips.find((c) => c.getAttribute('aria-pressed') === 'true') || chips[0];
    preset && apply(preset);
  });

  $$('[data-proto-action]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    toast(b.dataset.protoAction);
  }));

  // ---- Add to cart (drawer) -> cart page ----
  $$('[data-add-to-cart]').forEach((btn) => btn.addEventListener('click', async () => {
    const id = Number(btn.dataset.variantId);
    if (!id) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'That wheel could not be added.');
      }
      window.location.href = '/cart';
    } catch (err) {
      toast(err.message);
      btn.disabled = false;
      btn.textContent = label;
    }
  }));

  // ---- YouTube: thumbnail first, player only on click (keeps the page fast) ----
  $$('[data-youtube]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${a.dataset.youtube}?autoplay=1&rel=0`;
    iframe.title = a.querySelector('img') ? a.querySelector('img').alt : 'Video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    a.replaceWith(iframe);
  }));

  // ---- Ship-by / arrive-between estimate (honest urgency) ----
  // Carismo's FAQ: in-stock orders ship within 24-48 hours; US transit is 1-5 business days.
  // Business days only, US holidays ignored. The Shopify port reads these numbers from a theme
  // setting the ops team controls. Never a resetting countdown.
  const addBusinessDays = (date, n) => {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  $$('[data-ship-window]').forEach((el) => {
    const handling = Number(el.dataset.handlingDays || 2);
    const tMin = Number(el.dataset.transitMin || 1);
    const tMax = Number(el.dataset.transitMax || 5);
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const shipBy = addBusinessDays(now, handling);
    $('[data-ship-by]', el).textContent = fmt(shipBy);
    $('[data-arrive]', el).textContent = `${fmt(addBusinessDays(shipBy, tMin))} – ${fmt(addBusinessDays(shipBy, tMax))}`;
  });

  // ---- Before / after slider ----
  $$('[data-compare]').forEach((box) => {
    const range = $('input[type=range]', box);
    const set = (v) => box.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => set(range.value));
    set(range.value);
  });

  // ---- Two-step vehicle picker (Make -> Model) ----
  $$('[data-picker]').forEach((form) => {
    const all = window.CARISMO_VEHICLES;
    const CATCH_ALL = 'Other / not listed';
    const chosen = form.dataset.pickerMakes ? form.dataset.pickerMakes.split(',').map((m) => m.trim()) : Object.keys(all);
    const makes = chosen.filter((m) => m !== CATCH_ALL).concat(CATCH_ALL);
    const mode = form.dataset.pickerMode || 'collection';
    const query = form.dataset.pickerQuery || '';
    const make = $('[data-picker-make]', form);
    const model = $('[data-picker-model]', form);
    const out = $('[data-picker-out]', form);
    const link = $('[data-picker-link]', form);
    makes.forEach((m) => all[m] && make.add(new Option(m, m)));
    make.addEventListener('change', () => {
      model.innerHTML = '<option value="">Model</option>';
      model.disabled = !make.value;
      (all[make.value] || []).forEach((row) => model.add(new Option(row.label, row.label)));
      out.hidden = true;
    });
    model.addEventListener('change', () => {
      const row = (all[make.value] || []).find((r) => r.label === model.value);
      if (!row) { out.hidden = true; return; }
      const path = mode === 'build' && row.build ? row.build : row.url;
      $('[data-picker-name]', out).textContent = `${make.value} ${row.label}`;
      $('[data-picker-note]', out).textContent = row.note;
      link.href = SITE + path + (path.startsWith('/collections/') ? query : '');
      out.hidden = false;
    });
  });

  // ---- "Which grip is right for you" flow ----
  $$('[data-quiz]').forEach((quiz) => {
    const steps = $$('[data-quiz-step]', quiz);
    const result = $('[data-quiz-result]', quiz);
    const progress = $('[data-quiz-progress]', quiz);
    const scores = {};
    let i = 0;
    const show = () => {
      steps.forEach((s, n) => { s.hidden = n !== i; });
      if (progress) progress.textContent = `Question ${i + 1} of ${steps.length}`;
    };
    steps.forEach((step) => $$('[data-score]', step).forEach((btn) => btn.addEventListener('click', () => {
      btn.dataset.score.split(' ').forEach((k) => { scores[k] = (scores[k] || 0) + 1; });
      i++;
      if (i < steps.length) { show(); return; }
      steps.forEach((s) => { s.hidden = true; });
      if (progress) progress.textContent = 'Your match';
      const order = (quiz.dataset.tiebreak || '').split(' ');
      const winner = Object.entries(scores).sort((a, b) => (b[1] - a[1]) || (order.indexOf(a[0]) - order.indexOf(b[0])))[0][0];
      $$('[data-quiz-answer]', result).forEach((a) => { a.hidden = a.dataset.quizAnswer !== winner; });
      result.hidden = false;
    })));
    $$('[data-quiz-restart]', quiz).forEach((b) => b.addEventListener('click', () => {
      Object.keys(scores).forEach((k) => delete scores[k]);
      i = 0; result.hidden = true; show();
    }));
    show();
  });

  // ---- "Message us" → the store's Respond.io widget ----
  // Any link to "#message-us" opens the Respond.io speed dial (Text, Messenger, Instagram, WhatsApp).
  // It is the same widget layout/theme.liquid loads site-wide — keep RESPOND_SRC in sync with it.
  // This widget type has no public open() API ($respond only exists for Website Chat), so we press
  // its own "Expand Widgets" button. If it hasn't rendered within 4 seconds, fall back to a text.
  const messageLinks = $$('a[href="#message-us"]');
  if (messageLinks.length) {
    const RESPOND_SRC = 'https://cdn.respond.io/widget/widget.js?wId=d6c04e0f-7afd-40d8-bf46-fde9368b540a';
    const FALLBACK = 'sms:+19145674499';
    const OPEN_CLASS = 'lp-messaging-open';
    const loadWidget = () => {
      if (document.getElementById('respondio__growth_tool')) return;
      const s = document.createElement('script');
      s.id = 'respondio__growth_tool';
      s.async = true;
      s.src = RESPOND_SRC;
      document.body.appendChild(s);
    };
    const dialButton = () => {
      const host = document.querySelector('respond-io-widget');
      return host && host.shadowRoot ? host.shadowRoot.querySelector('button[aria-label="Expand Widgets"]') : null;
    };
    let watched = null;
    const hideWhenClosed = (btn) => {
      if (watched === btn) return;
      watched = btn;
      new MutationObserver(() => {
        if (!btn.classList.contains('open')) {
          setTimeout(() => { if (!btn.classList.contains('open')) document.documentElement.classList.remove(OPEN_CLASS); }, 250);
        }
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    };
    const openMessaging = async () => {
      loadWidget();
      let btn = dialButton();
      for (let waited = 0; !btn && waited < 4000; waited += 100) {
        await new Promise((r) => setTimeout(r, 100));
        btn = dialButton();
      }
      if (!btn) { window.location.href = FALLBACK; return; }
      document.documentElement.classList.add(OPEN_CLASS);
      hideWhenClosed(btn);
      if (!btn.classList.contains('open')) btn.click();
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(loadWidget, { timeout: 2500 });
    else setTimeout(loadWidget, 1500);
    messageLinks.forEach((a) => {
      a.addEventListener('pointerdown', loadWidget, { once: true });
      a.addEventListener('click', (e) => {
        e.preventDefault();
        // From inside the buy drawer, close it first: otherwise the dial stacks on the drawer and hides its close button.
        if (a.closest('[data-drawer]')) closeDrawer();
        openMessaging();
      });
    });
  }

  // ---- Short booking form (prototype stand-in for the Cowlendar embed) ----
  $$('[data-booking]').forEach((form) => form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!form.reportValidity()) return;
    form.hidden = true;
    const done = form.nextElementSibling;
    if (done) done.hidden = false;
  }));
})();
